<template>
  <div>
    <dara-row>
      <dara-col class="d-flex justify-content-center mb-5">
        <dara-image
          fit="cover"
          :src="urlImage"
          :height="200"
          :width="200"
          class="p--lg el-avatar--circle" />
        <dara-button class="button-image-blue-color" @click="disableChangeImage = !disableChangeImage">{{ $t('change-profile-image') }}</dara-button>
      </dara-col>
    </dara-row>
    <dara-row v-if="!disableChangeImage">
      <dara-col class="d-flex justify-content-center mb-5">
        <el-upload
          class="upload-box"
          drag
          action=""
          :auto-upload="false"
          :on-change="handleImport"
          :on-remove="handleRemove"
          :limit="1"
          :on-exceed="handleExceed">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{ $t('drop-file-here-or') }} <em>{{ $t('click-to-upload') }}</em></div>
          <div slot="tip" class="el-upload__tip">{{ $t('jpg-png-files-with-size-less-than-500kb') }}</div>
        </el-upload>
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.name"
          :label="$t('first-name')+'*'"
          type="text"
          :name="$t('first-name-field')"
          rules="required"
          :placeholder="$t('user-first-name-placeholder')" />
      </dara-col>
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.last_name"
          :label="$t('last-name')+'*'"
          type="text"
          :name="$t('last-name-field')"
          rules="required"
          :placeholder="$t('user-last-name-placeholder')" />
      </dara-col>
    </dara-row>
    <dara-row class="mt-2">
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.email"
          :label="$t('email')+'*'"
          type="email"
          :name="$t('email-field')"
          rules="required"
          :placeholder="$t('user-email-placeholder')" />
      </dara-col>
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.phone"
          :label="$t('phone')"
          type="text"
          :name="$t('phone-field')"
          rules="min:8"
          placeholder="(___) ____-____" />
      </dara-col>
    </dara-row>
    <dara-row class="mt-2">
      <dara-col :xs="24" :span="12">
        <dara-select
          v-bind="$attrs"
          :label="$t('country')+'*'"
          :name="$t('country-field')"
          rules="required"
          :value="user.country"
          class="mb-0"
          @on-change="onCountryChange">
          <option value="null" disabled>{{ $t('select-country') }}</option>
          <option
            v-for="country in countries"
            :key="country.key"
            :value="country.key">
            {{ $t(country.value) }}
          </option>
        </dara-select>
      </dara-col>
      <dara-col :xs="24" :span="12">
        <dara-select
          ref="states"
          v-bind="$attrs"
          :label="$t('state')+'*'"
          :name="$t('state-field')"
          rules="required"
          :value="user.state"
          class="mb-0"
          :disabled="!user.country"
          @on-change="onStateChange">
          <option value="null" disabled>{{ $t('select-state') }}</option>
          <option
            v-for="state in states"
            :key="state.key"
            :value="state.key">
            {{ state.value }}
          </option>
        </dara-select>
      </dara-col>
    </dara-row>
    <dara-row class="mt-2">
      <dara-col :xs="24" :span="12">
        <dara-select
          ref="cities"
          v-bind="$attrs"
          :label="$t('city')+'*'"
          :name="$t('city-field')"
          rules="required"
          :value="user.city"
          class="mb-0"
          :disabled="!user.state"
          @on-change="onCityChange">
          <option value="null" disabled>{{ $t('select-city') }}</option>
          <option
            v-for="city in cities"
            :key="city.name"
            :value="city.name">
            {{ city.name }}
          </option>
        </dara-select>
      </dara-col>
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.zip_code"
          :label="$t('zip-code')"
          type="text"
          :name="$t('zip-code-field')"
          :placeholder="$t('user-zip-code-placeholder')" />
      </dara-col>
    </dara-row>
    <dara-row class="mt-2">
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.birthday"
          :label="$t('birthday')"
          type="date"
          :name="$t('birthday-field')"
          rules="" />
      </dara-col>
      <dara-col :xs="24" :span="12">
        <dara-input
          v-model="user.position"
          :label="$t('position')+'*'"
          type="text"
          :name="$t('position-field')"
          rules="required"
          :placeholder="$t('user-position-placeholder')" />
      </dara-col>
    </dara-row>
    <dara-row class="mt-2">
      <!-- <dara-col :xs="24" :span="12">
        <label for="gender" class="w-100 mb-3">{{ $t('gender') }}</label>
        <div id="gender" class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              id="maleOption"
              v-model="user.gender"
              type="radio"
              class="form-check-input"
              name="optionsRadios"
              value="Male">
            {{ $t('male') }}
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              id="femaleOption"
              v-model="user.gender"
              type="radio"
              class="form-check-input"
              name="optionsRadios"
              value="Female">
            {{ $t('female') }}
          </label>
        </div>
        <div class="form-check form-check-inline">
          <label class="form-check-label">
            <input
              id="otherOption"
              v-model="user.gender"
              type="radio"
              class="form-check-input"
              name="optionsRadios"
              value="Other">
            {{ $t('other') }}
          </label>
        </div>
      </dara-col> -->
      <dara-col :xs="24" :span="12">
        <dara-select
          :name="$t('language-field')"
          :label="$t('language')+'*'"
          rules="required"
          :value="user.language"
          @on-change="onLanguageChange">
          <option :value="null" disabled>{{ $t('select-language') }}</option>
          <option
            v-for="language in languages"
            :key="language.locale"
            :value="language.locale">
            {{ language.title }}
          </option>
        </dara-select>
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col :xs="24">
        <dara-textarea
          v-model="user.biography"
          :label="$t('biography')"
          type="text"
          :name="$t('biography-field')"
          :placeholder="$t('user-bio-placeholder')" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col>
        <dara-header size="md" class="mt-5 mb-3">{{ $t('change-password') }}</dara-header>
      </dara-col>
      <dara-col :xs="24" :span="12">
        <label class="mb-2" for="password">{{ $t('password') }}</label>
        <dara-input
          id="password"
          v-model="user.password"
          type="text"
          :name="$t('password-field')"
          class="password"
          autocomplete="off"
          rules="min:8"
          placeholder="********" />
      </dara-col>
      <dara-col :xs="24" :span="12">
        <label class="mb-2" for="confirm_password">{{ $t('confirm-password') }}</label>
        <dara-input
          id="confirm_password"
          v-model="user.password2"
          type="text"
          :name="$t('confirm-password-field')"
          class="password"
          autocomplete="off"
          rules="min:8"
          placeholder="********" />
      </dara-col>
    </dara-row>
  </div>
</template>

<script>

import { COUNTRIES, BRAZIL, CANADA, UNITED_STATES } from '@/assets/resources/state-country';
import { CITIES_OF_BRAZIL } from '@/assets/resources/cities_of_brazil';
import { CITIES_OF_CANADA } from '@/assets/resources/cities_of_canada';
import { CITIES_OF_UNITED_STATES } from '@/assets/resources/cities_of_united_states';
import { toastError } from '@/services/toastService';
import { getCurrentStoredUser } from '@/modules/user/user.service';
import { NO_ARTICLE_IMAGE } from '@/modules/article/article.constants';
import { getImageFromAssets } from '@/helpers/images';
import { formatDate, DATE_FORMATS } from '@/helpers/date';
import { translate } from '@/services/translate.service';

export default {
  name: 'DaraSettingProfileForm',
  inject: ['userEditVm'],
  data() {
    return {
      countries: COUNTRIES,
      states: null,
      cities: null,
      disableChangeImage: true,
      user: this.userEditVm.user,
      urlImage: getImageFromAssets(NO_ARTICLE_IMAGE),
      languages: [
        { locale: 'en', title: 'English' },
        { locale: 'pt-br', title: 'Português' },
      ],
    };
  },
  mounted() {
    this.userAvatar();
    this.mountLocationInfo();
    this.user.birthday = formatDate(this.user.birthday, DATE_FORMATS.short);
  },
  methods: {
    userAvatar() {
      if (getCurrentStoredUser().profile_pic) {
        this.urlImage = getCurrentStoredUser().profile_pic;
      }
    },
    handleImport(file) {
      this.user.uploadFile = file.raw;
      const reader = new FileReader();
      reader.readAsDataURL(file.raw);
      reader.onload = () => {
        this.urlImage = reader.result;
      };
      this.disableChangeImage = true;
    },
    handleRemove() {
      if (getCurrentStoredUser().profile_pic) {
        this.urlImage = getCurrentStoredUser().profile_pic;
      } else {
        this.urlImage = getImageFromAssets(NO_ARTICLE_IMAGE);
      }
      this.user.uploadFile = null;
    },
    handleExceed(files, fileList) {
      toastError(`${translate('the-limit-is-one-you-selected')}${files.length + fileList.length}
      ${translate('totally-please-first-remove-the-unwanted-file')}`);
    },
    onLanguageChange(locale) {
      this.user.language = locale;
    },
    onCountryChange(country) {
      this.user.country = country;
      this.user.state = null;
      this.user.city = null;
      this.$refs.states.localValue = null;
      this.$refs.cities.localValue = null;
      if (country === 'brazil') {
        this.states = BRAZIL;
      } else if (country === 'canada') {
        this.states = CANADA;
      } else {
        this.states = UNITED_STATES;
      }
    },
    onStateChange(state) {
      this.user.state = state;
      this.user.city = null;
      this.$refs.cities.localValue = null;
      if (this.user.country === 'brazil') {
        this.cities = CITIES_OF_BRAZIL[state];
      } else if (this.user.country === 'canada') {
        this.cities = CITIES_OF_CANADA[state];
      } else {
        this.cities = CITIES_OF_UNITED_STATES[state];
      }
    },
    onCityChange(city) {
      this.user.city = city;
    },
    mountLocationInfo() {
      if (this.user.country === 'brazil') {
        this.states = BRAZIL;
        this.cities = CITIES_OF_BRAZIL[this.user.state];
      } else if (this.user.country === 'canada') {
        this.states = CANADA;
        this.cities = CITIES_OF_CANADA[this.user.state];
      } else {
        this.states = UNITED_STATES;
        this.cities = CITIES_OF_UNITED_STATES[this.user.state];
      }
    },
  },
};
</script>

<style scoped>
  .button-image-blue-color {
    position: absolute;
    top: 80%;
  }
  .password {
    -webkit-text-security: disc;
  }
</style>
